<div class="row px-5 d-flex justify-content-center align-items-center">
  <img class="col-12 w-25" src="assets/images/isempty.png" alt="..." />
  <h2 class="col-12 my-3 text-center tw-text-xl" style="color: #727272">{{ message | translate }}</h2>
</div>
